
import { mapState, mapMutations } from 'vuex';

export default {
  name: 'Multibanco',

  data() {
    return {
      active: false,
    };
  },

  computed: {
    ...mapState(['order', 'patientId', 'marketing', 'method']),
  },

  methods: {
    ...mapMutations(['setMethod']),

    async pay() {
      this.$bolev.metaEvent({
        type: 'paymentInitiated',
        patientId: this.patientId,
      });
      try {
        const { data } = await this.$bolev.hiPay({
          data: {
            payment_product: 'multibanco',
          },
          patientId: this.patientId,
          orderId: this.order.id,
          marketing: this.marketing,
        });
        switch (data.state) {
          case 'pending':
          case 'completed':
            this.$emit('success', { method: 'multibanco', state: data.state });
            break;
          case 'forwarding':
            window.location.href = data.url;
            break;
          case 'declined':
          case 'error':
          case 'unknown':
          default:
            this.$emit('fail', data);
            break;
        }
      } catch (e) {
        this.$emit('fail', 'unknown');
      }
    },
  },
};
